/*eslint-disable*/
const cdnLink = '//ugc.hitv.com/platform_oss/1614043449563/captcha-sdk.js';

import CryptoJS from 'crypto-js';

export const TYPE_MAP = {
  slide: 'SLIDE_NEW',
  click: 'CLICK',
  operation: 'OPERATION',
  char: 'CHAR',
};

export const TIP_MAP = {
  SLIDE: '拖动下方滑块完成拼图',
  CLICK: '点击文字完成验证',
  slide: '拖动下方滑块完成拼图',
  click: '点击文字完成验证',
};

export const w = 300; // 宽度
export const h = 200; // 高度
export const RISK_SUID = 'risk_suid';

export const isIE = window.navigator.userAgent.indexOf('Trident') > -1;

export function createCanvas(width, height) {
  var canvas = document.createElement('canvas');
  canvas.width = width || w;
  canvas.height = height || h;
  return canvas.getContext('2d');
}

export function getRandomNumberByRange(start, end) {
  return Math.round(Math.random() * (end - start) + start);
}

export function createImg(onload, src) {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = onload;
  img.onerror = () => {
    img.setSrc(getRandomImgSrc());
  };

  img.setSrc = function (src) {
    if (isIE) {
      // IE浏览器无法通过img.crossOrigin跨域，使用ajax获取图片blob然后转为dataURL显示
      const xhr = new XMLHttpRequest();
      xhr.onloadend = function (e) {
        const file = new FileReader(); // FileReader仅支持IE10+
        file.readAsDataURL(e.target.response);
        file.onloadend = function (e) {
          img.src = e.target.result;
        };
      };
      xhr.open('GET', src);
      xhr.responseType = 'blob';
      xhr.send();
    } else img.src = src;
  };
  let setSrc = '';
  if (src) {
    // 如果用户设置图片则使用
    setSrc = src;
  } else {
    setSrc = 'default-img';
  }
  img.setSrc(setSrc);

  return img;
}

export function createElement(tagName, className) {
  const elment = document.createElement(tagName);
  elment.className = className;
  return elment;
}

export function addClass(tag, className) {
  tag.classList.add(className);
}

export function removeClass(tag, className) {
  tag.classList.remove(className);
}

export function removeNodes(parent) {
  //当parent下还存在子节点时 循环继续
  while (parent.hasChildNodes()) {
    parent.removeChild(parent.firstChild);
  }
}

export function drawPiece(ctx, x, y) {
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
  ctx.lineTo(x + l, y);
  ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
  ctx.lineTo(x + l, y + l);
  ctx.lineTo(x, y + l);
  ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
  ctx.lineTo(x, y);
  ctx.stroke();
}

export function drawPieceInsideShadow(ctx, x, y) {
  // 第一步生成一个 piece 图形模板
  let piece = document.createElement('canvas');
  piece.width = w;
  piece.height = h;
  let pieceCtx = piece.getContext('2d');
  pieceCtx.fillStyle = 'white';

  drawPiece(pieceCtx, x, y);
  pieceCtx.lineWidth = 1;
  pieceCtx.strokeStyle = 'rgba(0, 0, 0, 1)';
  pieceCtx.stroke();
  pieceCtx['clip']();
  // document.body.appendChild(piece);

  // 第二步生成 piece 外围黑边准备用于内投影
  var hole = document.createElement('canvas');
  var holeContext = hole.getContext('2d');
  hole.width = w;
  hole.height = h;

  //first, I draw a big black rect
  holeContext.fillStyle = '#000000';
  holeContext.fillRect(0, 0, w, h);
  //then I use the image to make an hole in it
  holeContext.globalCompositeOperation = 'xor';

  drawPiece(holeContext, x, y);
  holeContext.lineWidth = 0;
  holeContext.fill();

  // 第三步生成内shadow
  var shadow = document.createElement('canvas');
  var shadowContext = shadow.getContext('2d');
  shadow.width = w;
  shadow.height = h;
  shadowContext.filter = 'drop-shadow(0px 0px ' + '5px #000000 ) ';

  // 默认 source-over 模式下叠加阴影，destination-out 模式...
  for (let i = 0; i < 4; i++) {
    shadowContext.drawImage(hole, 0, 0);
  }
  shadowContext.globalCompositeOperation = 'destination-out';
  shadowContext.drawImage(hole, 0, 0);

  // 第四步应用shadow
  ctx.drawImage(shadow, 0, 0);
}

export function drawBlock(img, ctx, x, y) {
  // 第一步 生成包含图像的 piece 方块
  ctx.lineWidth = 0.5;
  ctx.fillStyle = 'rgba(0, 0, 0, 0.35)';
  ctx.strokeStyle = 'rgba(253,255,29,0.7)';
  drawPiece(ctx, x, y);
  ctx.clip();
  ctx.globalCompositeOperation = 'source-over';

  // 设置图像及边长
  ctx.drawImage(img, 0, 0, w, h);
  const pieceY = y - r * 2 - 1;
  const ImageData = ctx.getImageData(x - 3, pieceY, L, L);
  ctx.canvas.width = L;
  ctx.putImageData(ImageData, 0, pieceY);

  // 第二步生成外shadow piece
  let shaodwCtx = createCanvas();
  shaodwCtx.canvas.width = L;
  shaodwCtx.shadowColor = 'black';
  shaodwCtx.shadowBlur = 6;
  shaodwCtx.shadowOffsetX = 2;
  shaodwCtx.shadowOffsetY = 5;
  drawPiece(shaodwCtx, 3, y);
  shaodwCtx.lineWidth = 1;
  shaodwCtx.fillStyle = 'rgba(0, 0, 0, 1)';
  shaodwCtx.strokeStyle = 'rgba(0, 0, 0, 1)';
  shaodwCtx.stroke();
  shaodwCtx.fill();

  let compositeCtx = createCanvas();
  compositeCtx.canvas.width = L;
  compositeCtx.drawImage(shaodwCtx.canvas, 0, 0);
  compositeCtx.drawImage(ctx.canvas, 0, 0);
  // document.body.appendChild(compositeCtx.canvas);

  ctx.drawImage(compositeCtx.canvas, 0, 0);
}

export function sum(x, y) {
  return x + y;
}

export function square(x) {
  return x * x;
}

export function getSrc(type, source) {
  if (!type || !source) return '';
  if (
    type.toUpperCase() === TYPE_MAP.slide ||
    type.toUpperCase() === TYPE_MAP.click
  ) {
    return source;
  } else {
    return `data:image/png;base64,${source}`;
  }
}

export function resetSize(_this) {
  let shadowImgWidth,
    shadowImgHeight,
    barWidth,
    barHeight,
    blockWidth,
    blockHeight,
    circleRadius; //图片的宽度、高度，移动条的宽度、高度
  const parentWidth =
    _this.$element.parentNode.clientWidth || $(window).width();
  const parentHeight =
    _this.$element.parentNode.clientWidth || $(window).height();

  if (_this.options.imgSize.width.indexOf('%') != -1) {
    shadowImgWidth =
      (parseInt(_this.options.imgSize.width) / 100) * parentWidth + 'px';
  } else {
    shadowImgWidth = _this.options.imgSize.width;
  }

  if (_this.options.imgSize.height.indexOf('%') != -1) {
    shadowImgHeight =
      (parseInt(_this.options.imgSize.height) / 100) * parentHeight + 'px';
  } else {
    shadowImgHeight = _this.options.imgSize.height;
  }

  if (_this.options.barSize.width.indexOf('%') != -1) {
    barWidth =
      (parseInt(_this.options.barSize.width) / 100) * parentWidth + 'px';
  } else {
    barWidth = _this.options.barSize.width;
  }

  if (_this.options.barSize.height.indexOf('%') != -1) {
    barHeight =
      (parseInt(_this.options.barSize.height) / 100) * parentHeight + 'px';
  } else {
    barHeight = _this.options.barSize.height;
  }

  if (_this.options.blockSize) {
    if (_this.options.blockSize.width.indexOf('%') != -1) {
      blockWidth =
        (parseInt(_this.options.blockSize.width) / 100) * parentWidth + 'px';
    } else {
      blockWidth = _this.options.blockSize.width;
    }

    if (_this.options.blockSize.height.indexOf('%') != -1) {
      blockHeight =
        (parseInt(_this.options.blockSize.height) / 100) * parentHeight + 'px';
    } else {
      blockHeight = _this.options.blockSize.height;
    }
  }

  if (_this.options.circleRadius) {
    if (_this.options.circleRadius.indexOf('%') != -1) {
      circleRadius =
        (parseInt(_this.options.circleRadius) / 100) * parentHeight + 'px';
    } else {
      circleRadius = _this.options.circleRadius;
    }
  }

  return {
    shadowImgWidth,
    shadowImgHeight,
    barWidth,
    barHeight,
    blockWidth,
    blockHeight,
    circleRadius,
  };
}

/**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行（时间戳版）， false - 延迟执行（定时器版）
 */
export function throttle(func, wait, immediate = false) {
  if (immediate) {
    var previous = 0;
  } else {
    var timer;
  }
  return function () {
    var context = this; // 注意 this 指向
    var args = arguments; // arguments中存着event
    if (immediate) {
      var now = Date.now();

      if (now - previous > wait) {
        func.apply(context, args);
        previous = now;
      }
    } else {
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          func.apply(context, args);
        }, wait);
      }
    }
  };
}

// AES解密， encryptedBase64 - base64编码密文， key - 明文密钥
export function decryptAES(encryptedBase64, key) {
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, parseKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  // 将解密后的数据转换为UTF8字符串
  const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedData;
}

// AES加密， message - 需要加密的明文信息 key - 明文密钥
export function encryptAES(message, key) {
  const parseKey = CryptoJS.enc.Utf8.parse(key);
  const encryptedData = CryptoJS.AES.encrypt(message, parseKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return encryptedData;
}

export const refreshIconSrc =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAjCAMAAAAt8pNWAAAAbFBMVEUAAACOjo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo6Ojo644IB2AAAAI3RSTlMAB/LugA7e08a0IuO+rFBMMikScZmSiHtkORltVejIUkI8Vr8ftFIAAAEsSURBVDjLdZPZloMwCEDRRKtxj/vSTjv8/z9OiHo6RnIfNEeugHAElwj8BFWfCETMcjlz8WUQ+CVeA1doQrySlY4h8UZ3TbMhYlhM9aLVe3yhJb923aajhpO62JUzSwl3foQtdLwdKkZpYlIqOmqBKTAoyhJTHWlVhhINkzlku8qQmsgD4IOE5IyaIs0xKrZZeJhIS6mInjMGEyiMRyTs0jfbiPALMJvQE0K/ECXUITzNdfYLKGwfv16B+qAtDpzRoyWF1noMKjxm2dCt5hSJxMcOjl9uQPvPzGEis+SUioqcqlD8coU+VYwbttkWLB0pgit0PgtyJIrvF+kxXa/j2xV8jW+ll3oqaBTb9cM6vCHd/yNzhPDWerDG/+PDAgyzzCmTSPoqAD+RG/wDj/8tA4+WpUsAAAAASUVORK5CYII=';
